import React, { useState } from "react";
import { Helmet } from "react-helmet";
import HeaderThree from "../header/HeaderThree";
import FooterTwo from "../footer/FooterTwo";
import CopyRightTwo from "../footer/CopyRightTwo";
import "../../assets/scss/carrier.scss";
import axios from "axios";
import { API_URL } from "../../config";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";


const Carrier = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    position: "",
    coverLetter: "",
    resume: null,
  });
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState("");

  const validateForm = () => {
    let tempErrors = {};
    let isValid = true;

    // Full Name validation
    if (!formData.fullName.trim()) {
      tempErrors.fullName = "Full name is required";
      isValid = false;
    } else if (formData.fullName.length < 2) {
      tempErrors.fullName = "Name must be at least 2 characters long";
      isValid = false;
    }

    // Email validation
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!formData.email) {
      tempErrors.email = "Email is required";
      isValid = false;
    } else if (!emailRegex.test(formData.email)) {
      tempErrors.email = "Invalid email format";
      isValid = false;
    }

    // Phone validation
    const phoneRegex = /^[0-9]{12}$/;
    if (!formData.phone) {
      tempErrors.phone = "Phone number is required";
      isValid = false;
    } else if (!phoneRegex.test(formData.phone.replace(/[^0-9]/g, ""))) {
      tempErrors.phone = "Invalid phone number (10 digits required)";
      isValid = false;
    }

    // Position validation
    if (!formData.position) {
      tempErrors.position = "Please select a position";
      isValid = false;
    }

    // Cover Letter validation
    if (!formData.coverLetter.trim()) {
      tempErrors.coverLetter = "Cover letter is required";
      isValid = false;
    } else if (formData.coverLetter.length < 50) {
      tempErrors.coverLetter =
        "Cover letter must be at least 50 characters long";
      isValid = false;
    }

    // Resume validation
    if (!formData.resume) {
      tempErrors.resume = "Please upload your resume";
      isValid = false;
    } else {
      const fileSize = formData.resume.size / 1024 / 1024; // in MB
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      if (fileSize > 5) {
        tempErrors.resume = "File size must be less than 5MB";
        isValid = false;
      } else if (!allowedTypes.includes(formData.resume.type)) {
        tempErrors.resume = "Only PDF, DOC, or DOCX files are allowed";
        isValid = false;
      }
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        resume: file,
      }));

      if (errors.resume) {
        setErrors((prev) => ({
          ...prev,
          resume: "",
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("");

    if (validateForm()) {
      try {
        const formPayload = new FormData();
        formPayload.append("fullName", formData.fullName);
        formPayload.append("emailAddress", formData.email);
        formPayload.append("phoneNumber", formData.phone);
        formPayload.append("position", formData.position);
        formPayload.append("coverLetter", formData.coverLetter);
        formPayload.append("resume", formData.resume);

        const response = await axios.post(
          `${API_URL}/api/careers`,
          formPayload,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        console.log("Form submitted successfully:");
        console.log(response.data);

        // Reset form after successful submission
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          position: "",
          coverLetter: "",
          resume: null,
        });

        setSubmitStatus("success");
        alert("Form submitted successfully! We'll get back to you soon.");
      } catch (error) {
        console.error("Error submitting form:", error);
        setSubmitStatus("error");

        if (error.response) {
          // The server responded with an error
          switch (error.response.status) {
            case 400:
              alert("Invalid form data. Please check your inputs.");
              break;
            case 413:
              alert("Resume file is too large. Please upload a file smaller than 5MB.");
              break;
            case 415:
              alert("Invalid file type. Please upload a PDF, DOC, or DOCX file.");
              break;
            default:
              alert(error.response.data.message || "Error submitting form. Please try again.");
          }
        } else if (error.request) {
          // The request was made but no response was received
          alert("Network error. Please check your internet connection and try again.");
        } else {
          // Something happened in setting up the request
          alert("Error submitting form. Please try again.");
        }
      }
    } else {
      setSubmitStatus("error");
    }
  };

  return (
    <div className="main-page-wrapper">
      <Helmet>
        <title>Raiden Studios | Blockchain, DeFi, Gaming & VR Experts</title>
      </Helmet>
      <HeaderThree />
      <div className="carrier-section">
        <div className="container">
          <div className="hero-section text-center">
            <h1 className="hero-title" style={{ marginTop: 'revert' }}>
              Discover Your Passion's Purpose with Raiden
            </h1>
            <h2 className="hero-subtitle">
              Where Innovation Meets Opportunity
            </h2>
            <p className="hero-text">Join Our Creative & Dynamic Team</p>
          </div>

          <div className="career-form-container">
            <form className="career-form" onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    name="fullName"
                    className={`form-input ${errors.fullName ? "error" : ""}`}
                    placeholder="Enter your name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  {errors.fullName && (
                    <div className="error-message">{errors.fullName}</div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">Email Address</label>
                  <input
                    type="email"
                    name="email"
                    className={`form-input ${errors.email ? "error" : ""}`}
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  {errors.email && (
                    <div className="error-message">{errors.email}</div>
                  )}
                </div>

                <div className="form-group">
                  <label className="form-label">Phone Number</label>
                  <PhoneInput
                    country={"in"}
                    value={formData.phone}
                    placeholder="Enter your phone number"
                    onChange={(value) =>
                      setFormData((prev) => ({
                        ...prev,
                        phone: value,
                      }))
                    }
                    inputStyle={{
                      height: "55px",
                      paddingLeft: "60px",
                    }}
                    inputClass={`form-input ${errors.phone ? "error" : ""}`}
                  />
                  {errors.phone && (
                    <div className="error-message">{errors.phone}</div>
                  )}
                </div>


                <div className="form-group">
                  <label className="form-label">
                    Position You're Applying For
                  </label>
                  <select
                    name="position"
                    className={`form-input ${errors.position ? "error" : ""}`}
                    value={formData.position}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select a position</option>
                    <option value="developer">Software Developer</option>
                    <option value="gamedeveloper">Game Developer</option>
                    <option value="blockchain">Blockchain Developer</option>
                    <option value="digitalmarketing">Digital Marketing</option>
                    <option value="designer">UI/UX Designer</option>
                    <option value="other">Other</option>
                  </select>
                  {errors.position && (
                    <div className="error-message">{errors.position}</div>
                  )}
                </div>
              </div>

              <div className="form-group full-width">
                <label className="form-label">Cover Letter</label>
                <textarea
                  name="coverLetter"
                  className={`form-input ${errors.coverLetter ? "error" : ""}`}
                  placeholder="Tell us about yourself and why you want to join Raiden"
                  value={formData.coverLetter}
                  onChange={handleInputChange}
                  rows="4"
                  required
                ></textarea>
                {errors.coverLetter && (
                  <div className="error-message">{errors.coverLetter}</div>
                )}
              </div>

              <div className="file-upload-section">
                <div
                  className={`file-upload-content ${errors.resume ? "error" : ""
                    }`}
                >
                  <div className="upload-icon">
                    <i className="fa fa-cloud-upload"></i>
                  </div>
                  <div className="upload-text">
                    <h3>Upload Your Resume</h3>
                    <p>PDF, DOC, DOCX (Max size: 5MB)</p>
                  </div>
                  <input
                    type="file"
                    name="resume"
                    className="file-input"
                    accept=".pdf,.doc,.docx"
                    onChange={handleFileChange}
                    required
                  />
                  {errors.resume && (
                    <div className="error-message">{errors.resume}</div>
                  )}
                </div>
              </div>



              {submitStatus === "error" && (
                <div className="error-message text-center">
                  Please fix the errors before submitting.
                </div>
              )}

              <div className="form-footer d-flex justify-content-center">
                <button type="submit" className="submit-button btn-gradient">
                  Submit Application
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <footer className="theme-footer-two pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Carrier;
